import { IRegisterWithOwner } from "@prostocheck/shared";

import { findCashRegister } from "../../api";
import { useSession } from "../use-session";

/**
 * The register `CashRegisterPage`'s `:cashRegisterFn` route param names, out
 * of the list `Objects` returned at sign-in.
 */
export const useCashRegister = ({
  fiscalNumber,
}: {
  fiscalNumber: string | undefined;
}): IRegisterWithOwner | undefined => {
  const { session } = useSession();

  return findCashRegister({
    registers: session?.registers ?? [],
    fiscalNumber,
  });
};
